// Export mode enumeration
export const ExportMode = Object.freeze({
	DIRECT: true, // Direct download
	BACKGROUND: false, // Background export (with notification)
});

// Helper functions for better readability
export const ExportModeHelpers = {
	isDirect: (isDirectMode) => isDirectMode === ExportMode.DIRECT,
	isBackground: (isDirectMode) => isDirectMode === ExportMode.BACKGROUND,
	toString: (isDirectMode) => (isDirectMode ? 'direct' : 'background'),
};
